import React from "react";

export default function CopyTraderGuide() {
  return (
    <div className="CopyTraderGuide">
      <h1>Hello</h1>
    </div>
  );
}
